export default "__VITE_ASSET__DeuB7cJO__"